import React, { useState } from "react";
import { Newspaper, ExternalLink, RefreshCw } from "lucide-react";
import InternalNewsList from "../components/InternalNewsList";

const NEWS_URL = "https://gfnsoulnyc151fm.webradiosite.com/news/";

const News = () => {
  // key forces the iframe to remount when the user hits "Refresh"
  const [key, setKey] = useState(0);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      {/* Gold header bar (mirrors On Demand page look) */}
      <div
        data-testid="news-header"
        className="rounded-t-lg bg-gradient-to-r from-gold-dark via-gold to-gold-dark px-6 md:px-10 py-6 flex items-center justify-between gap-4"
      >
        <div className="flex items-center gap-4 min-w-0">
          <div className="w-10 h-10 shrink-0 rounded-full bg-black/90 grid place-items-center">
            <Newspaper className="w-5 h-5 text-gold" />
          </div>
          <div className="min-w-0">
            <div className="font-condensed uppercase tracking-[0.35em] text-[10px] text-black/70">
              GFN Presents
            </div>
            <div className="font-display text-3xl md:text-4xl leading-none text-black uppercase truncate">
              GFN Soul NYC · News
            </div>
          </div>
        </div>
        <div className="hidden sm:flex items-center gap-2 shrink-0">
          <button
            data-testid="news-refresh"
            onClick={() => setKey((k) => k + 1)}
            className="inline-flex items-center gap-2 bg-black/85 hover:bg-black text-gold font-condensed uppercase tracking-widest text-[10px] px-3 py-2 rounded-full transition-colors"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Refresh
          </button>
          <a
            href={NEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="news-open-external"
            className="inline-flex items-center gap-2 bg-black/85 hover:bg-black text-gold font-condensed uppercase tracking-widest text-[10px] px-3 py-2 rounded-full transition-colors"
          >
            <ExternalLink className="w-3.5 h-3.5" />
            Open Full Site
          </a>
        </div>
      </div>

      {/* Intro copy */}
      <div className="bg-jet-surface border-x border-gold/20 px-6 md:px-10 py-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <p className="font-body text-neutral-300 text-sm md:text-base max-w-3xl">
          The latest music, entertainment, and community stories from the GFN Soul NYC
          newsdesk — published straight from our FM 151 news wire.
        </p>
        <div className="flex sm:hidden gap-2">
          <button
            data-testid="news-refresh-mobile"
            onClick={() => setKey((k) => k + 1)}
            className="inline-flex items-center gap-2 border border-gold/50 hover:border-gold text-gold font-condensed uppercase tracking-widest text-[10px] px-3 py-2 rounded-full transition-colors"
          >
            <RefreshCw className="w-3.5 h-3.5" />
            Refresh
          </button>
          <a
            href={NEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="news-open-external-mobile"
            className="inline-flex items-center gap-2 border border-gold/50 hover:border-gold text-gold font-condensed uppercase tracking-widest text-[10px] px-3 py-2 rounded-full transition-colors"
          >
            <ExternalLink className="w-3.5 h-3.5" />
            Open
          </a>
        </div>
      </div>

      {/* Internal newsdesk (managed from /admin) */}
      <div className="bg-jet-surface border-x border-gold/20 px-6 md:px-10 pb-2">
        <InternalNewsList />
      </div>

      {/* Embed container — isolated in an iframe */}
      <div className="bg-jet-surface border-x border-b border-gold/20 rounded-b-lg p-2 md:p-4">
        <div
          className="rounded-md bg-white overflow-hidden"
          data-testid="news-embed-frame"
        >
          <iframe
            key={key}
            title="GFN Soul NYC News"
            src={NEWS_URL}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-presentation"
            className="w-full block"
            style={{ height: "1400px", border: "0" }}
          />
        </div>
      </div>

      {/* Fallback link — always visible in case the iframe is blocked */}
      <div
        data-testid="news-fallback"
        className="mt-4 mb-2 flex flex-col sm:flex-row items-start sm:items-center gap-3 justify-between rounded-lg border border-gold/25 bg-jet-surface px-5 py-4"
      >
        <div className="font-body text-sm text-neutral-300">
          Having trouble seeing the news feed above?{" "}
          <span className="text-gold">Open the full GFN news site in a new tab.</span>
        </div>
        <a
          href={NEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="news-fallback-cta"
          className="inline-flex items-center gap-2 bg-gold hover:bg-gold-light text-black font-condensed uppercase tracking-widest text-xs px-5 py-2.5 rounded-full transition-colors"
        >
          <ExternalLink className="w-4 h-4" />
          Read GFN News
        </a>
      </div>

      <div className="mt-4 mb-8 text-center font-condensed uppercase tracking-[0.35em] text-[10px] text-neutral-500">
        Published by GFN Soul NYC FM 151 · Wrapped in the GFN broadcast look
      </div>
    </div>
  );
};

export default News;
